import { ApplicationConfig, importProvidersFrom, provideNgReflectAttributes, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from '@app/app.routes';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '@environments/environment';
import { provideStore, StoreModule } from '@ngrx/store';
import { provideStoreDevtools, StoreDevtoolsModule } from '@ngrx/store-devtools';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RsCustomMatIconsModule } from '@rs-shared-lib/modules/rs-core/modules/rs-custom-mat-icons.module';
import { provideTitleStrategy } from '@rs-shared-lib/strategies/rs-title-strategy.service';
import { OrdAdminTitleStrategy } from '@shared/strategies/ord-admin-title-strategy.service';
import { RsCoreModule } from '@rs-shared-lib/modules/rs-core/rs-core.module';
import { UserInfoCookieAppName } from '@rs-shared-lib/modules/rs-core/modules/rs-authentication/enums/UserInfoCookieAppName.enum';
import { DateAdapter } from '@angular/material/core';
import { RsNativeDateAdapter } from '@rs-shared-lib/shared/adapters/rs-native-date-adapter';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

export const appConfig: ApplicationConfig = {
  providers: [
    // Do not rely on ng-reflect attributes; they are planned for deprecation in the future.
    provideNgReflectAttributes(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideTitleStrategy(OrdAdminTitleStrategy),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideStore(),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true
    }),
    provideAnimations(),
    importProvidersFrom(
      StoreModule.forRoot({}, {}),
      StoreDevtoolsModule.instrument({
          maxAge: 25,
          logOnly: environment.production,
          connectInZone: true
        }
      ),
      RsCoreModule.forRoot({
        appName: UserInfoCookieAppName.ORD_ADMIN,
        environment
      }),
      RsCustomMatIconsModule
    ),
    { provide: DateAdapter, useClass: RsNativeDateAdapter },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { autoFocus: true, width: '800px' } }
  ]
};
